import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NormalUI from './screens/normalUI';
import ModelUI from './screens/ModelUI';
import WildfirePlanningPageUI from './screens/PlanningPageUI';
import LandingPage from './screens/LandingPage/LandingPage';
import LandingPageNewUI from './screens/LandingPage/LandingPageNewUI';
import UsageAnalyticsPage from './screens/UsageAnalyticsPage';
import PodcastAnalyticsPage from './screens/PodcastAnalyticsPage';
import PlanningAppLanding from './screens/LandingPage/PlanningAppLanding';
import PodcastPage from './screens/PublicPodcastScreens/PodcastPage';
import ModelBuilderUI from './screens/ModelBuilderUI';
import PodcastPageV2 from './screens/PublicPodcastScreens/PodcastPageV2';
import PodcastPageWrapper from './screens/PublicPodcastScreens/PodcastPageWrapper';
import InteractiveMap from './screens/InteractiveMapUI';
import MBTestChatScreen from './screens/ModelBuilder/MBTestChatScreen';
import InteractiveMapOld from './screens/InteractiveMapUI_backup';
import InteractiveMapMain from './screens/InteractiveMapMain';
import InteractiveMapEdit from './screens/InteractiveMaps/InteractiveMapUI_edit';
import MBChatComponent from './screens/SectionScreens/ModelBuilder/MBChatComponent';
import DomainPage from './screens/DomainPage';
import AudioTestPage from './screens/AudioTestPage';
import PodcastGeneratorTestPage from './screens/PodcastGeneratorTestPage';
import { AuthProvider } from './auth/AuthProvider';
import ProtectedRoute from './auth/ProtectedRoute';
import LoginPage from './auth/LoginPage';
import EditorLayout from './auth/EditorLayout';
import ContactUs from './screens/LandingPage/ContactUs';
import DataCollectionPage from './features/dataCollection/DataCollectionPage';
import LiveTicketsPage from './screens/LiveTicketsPage';
import PodcastListenPage from './features/podcastSharing/PodcastListenPage';


function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
        {/* Route for marketing landing page */}
        <Route path="/" element={<LandingPageNewUI />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/landing-legacy" element={<LandingPage />} />

        <Route path="/planningApp" element={<PlanningAppLanding />} />

        <Route path="/old" element={<NormalUI />} />

        <Route path="/podcast/ofsc" element={<PodcastPageWrapper />} />
        <Route path="/listen/:builderId/:runId" element={<PodcastListenPage />} />

        <Route path="/bovia/analytics" element={<UsageAnalyticsPage />} />
        <Route path="/analytics/:podcastId" element={<PodcastAnalyticsPage />} />

        {/* Route for Model UI */}
        <Route
          path="/model"
          element={(
            <ProtectedRoute>
              <EditorLayout title="WUI-Planner" contextLabel="" hideHeader>
                <ModelUI />
              </EditorLayout>
            </ProtectedRoute>
          )}
        />

        <Route path="/bovia/model" element={<ModelBuilderUI />} />

        <Route
          path="/builder/:simulationId"
          element={(
            <ProtectedRoute>
              <EditorLayout title="WUI-Builder" contextLabel="Simulation">
                <MBChatComponent />
              </EditorLayout>
            </ProtectedRoute>
          )}
        />

        <Route path="/bovia/map" element={<InteractiveMap />} />
        <Route path="/bovia/old_map" element={<InteractiveMapOld />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/live-tickets" element={<ProtectedRoute><EditorLayout title="Live tickets" contextLabel="" dark><LiveTicketsPage /></EditorLayout></ProtectedRoute>} />
        <Route
          path="/edit_podcast/:podcastId"
          element={(
            <ProtectedRoute>
              <EditorLayout>
                <InteractiveMapEdit />
              </EditorLayout>
            </ProtectedRoute>
          )}
        />

        {/* Route for Planning Page UI */}
        <Route path="/planning" element={<WildfirePlanningPageUI />} />

        <Route path="/podcasts/:podcastId" element={<InteractiveMapMain />} />
        <Route
          path="/try/wui-cast"
          element={(
            <InteractiveMapMain
              podcastIdOverride="sdge_demo"
              demoGate={{ optionalPromptAfter: 40, requiredPromptAt: 72 }}
            />
          )}
        />

        <Route path="/modelAI" element={<MBTestChatScreen chatId={"test_chat"}/>} />

        <Route path="/domain/:id" element={<DomainPage />} />
        <Route path="/audio-test" element={<AudioTestPage />} />
        <Route
          path="/podcast-generator-test"
          element={(
            <ProtectedRoute>
              <PodcastGeneratorTestPage />
            </ProtectedRoute>
          )}
        />
        <Route path="/data-collection/:id" element={<DataCollectionPage />} />

        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
